// extracted by mini-css-extract-plugin
export var label = "_kg-0";
export var treatmentCard = "_kg-1";